export const sales_organization = {
    ALGO: "Algoma",
    ATSL: "Amaja Tubular Servic",
    COND: "ColmenaConduit",
    DS1: "Siderca",
    GENE: "Geneva Struc. Tubes",
    HYCO: "Hydril Company",
    HYCP: "Hydril Canadian Comp",
    HYIN: "PT. Hydril Indonesia",
    IPPS: "ULTRA Premium Servic",
    IT09: "Dalmine",
    KPTL: "KAZAKHSTAN PIPES THR",
    MM: "Metalmecánica",
    MTLP: "Maverick Tube Corp.",
    PRUD: "PRUDENTIAL STEEL ULC",
    SIAT: "SIAT",
    SILN: "Silcotub",
    SPIJ: "Seamless Pipe Indone",
    SSPC: "Saudi Steel Pipe CO.",
    TAMS: "TAMSA",
    TBAY: "Tenaris Bay City",
    TCBV: "Tenaris Connect. BV",
    TEAB: "TGS S.A. Abu Dhabi",
    TEAU: "TGS Australia",
    TEAZ: "TGS Kazakhstan",
    TEBO: "TGS Bolivia",
    TECA: "TGS Canada",
    TECH: "Tenaris China",
    TECO: "Tenaris Coiled Tubes",
    TECU: "Tenaris Ecuador",
    TEDI: "TGS Denmark",
    TEEC: "TGS Ecuador",
    TEEG: "TGS Egypt",
    TEFR: "TGS France",
    TEKO: "TGS Korea",
    TELY: "TGS Libya",
    TENG: "TGS Nigeria",
    TENO: "TGS Norway",
    TEOS: "Oilfield Services",
    TEPA: "TGS Panama",
    TEPE: "TGS Perú",
    TEQA: "TGS - Branch Qatar",
    TESA: "Tenaris Saudi Arabia",
    TESG: "TGS Far East",
    TEUK: "TGS UK",
    TEUS: "TGS USA",
    TGSI: "TGS Iraq",
    TGSS: "TGS LLC",
    TGST: "TGS Thailand Ltd",
    TGSU: "TGS Uruguay",
    TRUS: "Tenaris Rods U.S.",
    TSYS: "TSYS S.A.",
    TUCA: "TuboCaribe",
    VESR: "Scrapservice"
};